import { env } from "../env/env";
import { getErrorMessage } from "../util/ErrorHandler";
import { AxiosError } from "axios";
import { PrintDto, PrintProductDto } from "../generated/account-client";

export function getUserFriendlyDescription(description: string): string {
  let desc = "";

  if (description) {
    if (description.toLowerCase().indexOf("[ds]") > -1) {
      desc = "Design Services";
    }

    if (description.toLowerCase().indexOf("renewal") > -1) {
      desc = "Plan Renewal";
    }

    if (description.toLowerCase().indexOf("refund") > -1) {
      desc = "Refund";
    }

    if (description.toLowerCase().indexOf("location") > -1) {
      desc = "Add-ons Renewal";
    }

    if (description.toLowerCase().indexOf("user") > -1) {
      desc = "Add-ons Renewal";
    }

    if (description.indexOf("sub:") > -1) {
      desc = description.split("sub:")[1];
    }
  }

  return desc;
}

export function getUserFriendlyPrintStatus(status: number): string {
  switch (status) {
    case 1:
      return "Pending";
    case 9:
      return "Cancelled";
    case 2:
      return "Processing";
    case 10:
      return "In Production";
    case 7:
      return "Paid";
    case 8:
      return "Shipped";
    default:
      return "";
  }
}

export function getPrintItemCount(print: PrintDto) {
  let count = 1;

  let orderItemMenuId: string | undefined;
  print.items?.forEach((i) => {
    const id = getPrintProductId(i);

    if (orderItemMenuId && orderItemMenuId !== id) {
      count++;
    }
    orderItemMenuId = id;
  });

  return count;
}

export function getPrintProductId(p: PrintProductDto) {
  return p.documentId && p.documentId !== "0"
    ? p.documentId
    : p.menuId || p.pdfId;
}

export function getInvoicePath(id: string) {
  return `/menu/billinghistory.do?purchase=${id}`;
}

export function getPrintInfoPath(id: number) {
  return `/print/catalog/account_history_info.php?order_id=${id}`;
}

export function isTimberDesign(product: PrintProductDto) {
  return !product.nextGen && !product.pdfUploaded;
}

export function getEditPrintDesignPath(print: PrintDto) {
  let url = "";

  if (print.items) {
    const product = print.items[0];
    const isTimber = isTimberDesign(product);
    if (isTimber) {
      url = env.timberContextPath + "/design?id=" + product.documentId;
    }
  }

  return url;
}

export function getPrintPreviewPath(print: PrintDto) {
  let url = "";
  if (print.items) {
    const product = print.items[0];
    url =
      (print.test ? "/template/dryrun/print/" : "/template/prod/print/") +
      print.id +
      "/" +
      print.menuId?.split("|")[0] +
      ".jpg";
    if (is3DProduct() && !isTimberDesign(product)) {
      url =
        "/imageservice/iserve/assetDownload?type=menu&op=get&height=168&page=1&id=" +
        print.menuId +
        "&check-reversed=true";
    }
  }
  return url;
}

function is3DProduct(/*sku: string*/): boolean {
  // var skus = ['4/0MHM12-10', '4/4MHM1-100-F', '4/4MHM2-100-F1', '4/4MHM3-100-F', '4/4MHM1-100-F1', '4/4MHM2-100-F'];
  // return skus.indexOf(sku) > -1 ? true : false;
  return false;
}

export function formatCreditCard(value: string) {
  return value
    .replace(/\W/gi, "")
    .replace(/(.{4})/g, "$1 ")
    .trim();
}

export function isBillingError(e: AxiosError) {
  return (
    getErrorMessage(e)
      .toLowerCase()
      .indexOf("could not determine taxing jurisdictions") > -1
  );
}
